import CompanyResource from "models/company-resources/companyResource";
import LocationDto from "../company-resources/location-dto";

export default class WorkforceResource extends CompanyResource {
  employedBy: string;
  effectiveDate: string;
  suffix: number;
  deaStartDate: string;
  deaExpireDate: string;
  contactLocations?: LocationDto[];
  companyId: string;
  companyName: string;
  cognitoUserId: number;
  isSystemUser: boolean;
  /**
   * OPS-2858. Maps to contacts.is_support_user. Must be sent on every save, or the
   * user silently drops out of the Support Users tab.
   */
  isSupportUser?: boolean;
}



// WEBPACK FOOTER //
// ./src/models/system-admin/workforce-resource.ts